<app-loader class="loader" [ngStyle]="{'display':displayStyles}"></app-loader>
